module.exports = __webpack_public_path__ + "img/closed_capsules.61f37eee.png";